import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";
import { SettingsRoutePaths } from "@shared/settings/settings-route-paths";

export const SETTING_SIDENAV_LINK = new InjectionToken<void>("SETTING_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "system-settings",
        label: "SETTINGS.ITEMS.SYSTEM_SETTINGS",
        routerLink: "/settings/system-settings",
        icon: "settings-page",
        permissions: COMMON_GUARD_OPTIONS.SYSTEM_SETTINGS.VIEW.permissions,
      },
      {
        id: "other-settings",
        icon: "home",
        label: "OTHER_SETTINGS",
        items: [
          {
            id: "customer-type",
            label: "CUSTOMER_TYPE",
            routerLink: SettingsRoutePaths.customerType,
            permissions: COMMON_GUARD_OPTIONS.CUSTOMER_TYPE.VIEW.permissions,
          },
          {
            id: "vehicle-images",
            label: "VEHICLE_IMAGES",
            routerLink: SettingsRoutePaths.vehicleImages,
            permissions: COMMON_GUARD_OPTIONS.VEHICLE_IMAGE.VIEW.permissions,
          },
          {
            id: "vehicle-priority",
            label: "SETTINGS.ITEMS.VEHICLE_PRIORITY",
            routerLink: SettingsRoutePaths.vehiclePriority,
            permissions: COMMON_GUARD_OPTIONS.VEHICLE_PRIORITY.VIEW.permissions,
          },
          {
            id: "product",
            label: "PRODUCT",
            routerLink: SettingsRoutePaths.product,
            permissions: COMMON_GUARD_OPTIONS.PRODUCT.VIEW.permissions,
          },
          {
            id: "rental-house-settings",
            label: "RENTAL_HOUSE_SETTINGS",
            routerLink: SettingsRoutePaths.rentalHouseSettings,
            permissions: COMMON_GUARD_OPTIONS.RENTAL_HOUSE_SETTING.VIEW.permissions,
          },
          {
            id: "industry-sector",
            label: "INDUSTRY_SECTOR",
            routerLink: SettingsRoutePaths.industrySector,
            permissions: COMMON_GUARD_OPTIONS.INDUSTRY_SECTOR.VIEW.permissions,
          },
          {
            id: "dynamic-field",
            label: "DYNAMIC_FIELD",
            routerLink: SettingsRoutePaths.dynamicField,
            permissions: COMMON_GUARD_OPTIONS.DYNAMIC_FIELD.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
